import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { CustomFieldTypesEnum } from '@base/modules/rest/custom-field/enums/custom-field-types.enum';
import { CustomFieldModel } from '@base/modules/rest/custom-field/model/custom-field.model';
import { ObjectCompositeFilterModel } from '@base/modules/rest/object/model/object-composite-filter.model';
import { ValidatorFn } from '@angular/forms';
import { AbstractCustomFieldComponent } from '../../model/abstract-custom-field-component';

@Component({
  selector: 'app-field-edit',
  templateUrl: './field-edit.component.html',
  styleUrls: ['./field-edit.component.scss'],
})
export class FieldEditComponent {
  @Input() objectName: string;
  @Input() field: CustomFieldModel;
  @Input() label: string;
  @Input() controlName: string;
  @Input() data: any;
  @Input() filter: ObjectCompositeFilterModel;
  @Input() params: any;
  @Input() allowTextAsValue = false;
  @Input() waitFocusCallback: boolean;
  @Output() focusEvent = new EventEmitter<any>();

  @ViewChild('fieldEl') fieldEl: AbstractCustomFieldComponent;

  CustomFieldTypesEnum = CustomFieldTypesEnum;

  setValue(value: any): void {
    this.fieldEl.setValue(value);
  }

  setDisabled(disabled: boolean): void {
    this.fieldEl.setDisabled(disabled);
  }

  setValidators(validators: ValidatorFn[]): void {
    this.fieldEl.setValidators(validators);
  }
}
